import PostsScreen from "../modules/post/PostsScreen"

export default function Posts() {
  return (
    <>
      <PostsScreen />
    </>
  )
}
